import React, { SyntheticEvent, useEffect, useState } from "react";

import { Dropdown, DropdownProps } from "semantic-ui-react";

import ModConfirmCNMI from "react-lib/apps/common/cnmi/ModConfirm";

// Types
type ModConfirmEditNoteProps = {
  setProp: (key: string, value: any, callback?: () => void) => any;
  data?: { note: string; open: boolean };
  multiple?: boolean;
  stateKey: string;
  titleColor?: string;
  titleName?: string;
  options?: any[];
  onChange?: (data: Record<string, any>) => void;
  onClose?: () => void;
  onConfirm: () => void;
};

const ModConfirmEditNote = (props: ModConfirmEditNoteProps) => {
  const [options, setOptions] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setOptions(props.options ?? []);
  }, [props.options]);

  useEffect(() => {
    if (!props.data?.open) {
      setIsLoading(false);
    }
  }, [props.data?.open]);

  const handleAddOptions = (e: SyntheticEvent, v: any) => {
    setOptions([...options, { key: v.value, text: v.value, value: v.value }]);
  };

  const handleChange = (e: SyntheticEvent, v: DropdownProps) => {
    const data = { ...props.data, note: v.value };

    if (props.onChange) {
      props.onChange(data);
    } else {
      props.setProp(props.stateKey, data);
    }
  };

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    } else {
      props.setProp(props.stateKey, { note: "", open: false });
    }
  };

  const handleConfirm = () => {
    setIsLoading(true);

    props.onConfirm();
  };

  return (
    <ModConfirmCNMI
      approveButtonLoading={isLoading}
      approveButtonText="ยืนยันการแก้ไข"
      customGridButton={{ flex: 1 }}
      customGridGroup={{ padding: "0 1rem" }}
      denyButtonText="ยกเลิก"
      disabledApproveButton={props.multiple ? !props.data?.note.length : !props.data?.note}
      openModal={props.data?.open}
      titleColor={props.titleColor || "yellow"}
      titleName={props.titleName || "กรุณาใส่เหตุผลในการแก้ไขรายละเอียดรายการยา"}
      onApprove={handleConfirm}
      onDeny={handleClose}
      content={
        <div style={{ marginBottom: "-1rem" }}>
          <Dropdown
            multiple={props.multiple}
            value={props.data?.note}
            allowAdditions
            fluid
            search
            selection
            options={options}
            onAddItem={handleAddOptions}
            onChange={handleChange}
          />
        </div>
      }
    />
  );
};

ModConfirmEditNote.displayName = "ModConfirmEditNote";

export default React.memo(ModConfirmEditNote);
